import { NetworkStatus } from "@apollo/client";
import { useUpdateEffect } from "@hex-insights/core";
import { matchPath, useLocation } from "@hex-insights/router";
import { useUnreadMessagesCountQuery } from "../../../Utilities";

type UseUnreadMessagesAlertArgs = {
	messagingPagePath: string;
};

export function useUnreadMessagesAlert({ messagingPagePath }: UseUnreadMessagesAlertArgs) {
	const {
		data: unreadMessagesData,
		refetch,
		networkStatus,
	} = useUnreadMessagesCountQuery({
		fetchPolicy: "cache-and-network",
		pollInterval: 1000 * 60,
		notifyOnNetworkStatusChange: true,
	});
	const numUnreadMessages = unreadMessagesData?.unreadMessagesCount ?? 0;
	const location = useLocation();
	const isOnMessagingPage = matchPath(location.pathname, messagingPagePath);
	useUpdateEffect(() => {
		if (!isOnMessagingPage) {
			refetch();
		}
	}, [isOnMessagingPage, refetch]);
	const showUnreadMessagesAlert =
		!isOnMessagingPage && networkStatus !== NetworkStatus.refetch && numUnreadMessages > 0;

	return { numUnreadMessages, showUnreadMessagesAlert };
}
